// Zentralisierte User-ID-Verwaltung
export const getOrCreateUserId = (): string => {
  let userId = localStorage.getItem('cah_userId');
  if (!userId) {
    userId = crypto.randomUUID();
    localStorage.setItem('cah_userId', userId);
  }
  return userId;
};

// Hilfsfunktion für Spielername
export const getStoredPlayerName = (): string => {
  return localStorage.getItem('cah_playerName') || '';
};

export const setStoredPlayerName = (name: string): void => {
  localStorage.setItem('cah_playerName', name.trim());
};

// Debug-Funktion, um die lokalen IDs anzuzeigen
export const debugUserInfo = (): void => {
  console.log('Current User ID:', getOrCreateUserId());
  console.log('Current Player Name:', getStoredPlayerName());
}; 